import CreateCategoryDialog from './createCategoryDialog.container';

export default CreateCategoryDialog